import React from "react";
import { connect } from "react-redux";
import { primary } from "../../../../assets/colorPallet";
import { YEARLY, DESCENDANT_ORDER } from "../../../../config";

function DateBar({ currentCompanyDupontRatios }) {
  
  let array = currentCompanyDupontRatios?.datesFormatted.filter((value, index) => index >= 11);
  if(currentCompanyDupontRatios?.prefix === YEARLY) array = currentCompanyDupontRatios?.yearsFormatted;
      //we change dateArray according to the setting whether it is yearly or monthly

  if(currentCompanyDupontRatios?.dateOrder == DESCENDANT_ORDER) array = array.slice().reverse();
      //we must reverse the array if dateOrder is descendant order because data in Dupont ratio store is date ascendant

  return (
    <div className="flex items-center font-semibold text-white mt-10 mb-10">
      <div
        style={{ backgroundColor: primary }}
        className="absolute left-0 w-full h-12 z-10"
      />
      <div className="z-20" style={{ minWidth: "18em" }} />
      {array?.map((date) => (
        <div className="z-20" style={{ minWidth: "10em" }}>
          {date}
        </div>
      ))}
    </div>
  );
}

const mapStateToProps = (state) => ({
  currentCompanyDupontRatios: state.financialRatios.currentCompanyDupontRatios
});

export default connect(mapStateToProps)(DateBar);
